export default "__VITE_ASSET__MY0tJGMo__"